import { useEffect, useRef, useState } from 'react'
import { usePathname } from 'next/navigation'
import { Router } from 'next/router'
import CONFIG from 'config/current'

const AdBanner = ({ props, format = 'auto', slot = null, vertical }) => {
  if (slot === null) {
    return <></>
  }

  const [adsPushed, setAdsPushed] = useState(false)
  const additionalProps = CONFIG.adTest ? { 'data-adtest': 'on' } : {}
  const adRef = useRef(null)

  const pathname = usePathname()

  useEffect(() => {
    const pushAd = () => {
      if (adsPushed) {
        return
      }

      if (adRef.current && typeof window !== 'undefined') {
        try {
          if (!adRef.current.getAttribute('data-adsbygoogle-status')) {
            ;(window.adsbygoogle = window.adsbygoogle || []).push({})
            setAdsPushed(true)
          }
        } catch (e) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn('AdSense push error:', e)
          }
        }
      }
    }

    const handleRouteChange = () => {
      setTimeout(pushAd, 500) // Slight delay for route render to complete
    }

    pushAd()

    Router.events.on('routeChangeComplete', handleRouteChange)
    return () => Router.events.off('routeChangeComplete', handleRouteChange)
  }, [])

  const verticalAdStyles = {
    display: 'inline-block',
    width: '160px',
    height: '600px',
  }

  const style = {
    ...{
      display: 'block',
      overflow: 'hidden',
      maxWidth: '100vw',
    },
    ...(vertical && verticalAdStyles),
  }

  return (
    <ins
      ref={adRef}
      className={`adsbygoogle`}
      style={style}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive="true"
      data-ad-client={CONFIG.googleAdSensePublisherId}
      {...props}
      {...additionalProps}
      key={pathname}
    />
  )
}
export default AdBanner
